import clsx from 'clsx'

import { BRAND_ICONS, LOGO_FULL, LOGO_FULL_WHITE, LOGO_MARK } from '@/shared/ui/brandAssets'
import { useTheme } from '@/shared/theme/ThemeContext'

/**
 * Humania corre bajo la marca Safyro: el wordmark "SAFYRO" es el mismo en
 * toda la suite (Contadores, Fintrack); "Humania" es el nombre del producto,
 * así que va como texto al lado, no dentro del PNG. Cambia de versión sola
 * según el tema activo — mismo patrón que `Logo.tsx` de Safyro Finanzas
 * (`theme === "dark" ? "/logo-white.png" : "/logo-transparent.png"`), no un
 * prop manual: ya no hay chrome oscuro fijo (sidebar/topbar son planos y
 * siguen el tema), así que el logo tiene que seguirlo también.
 */
export function Logo({ className, ...props }) {
  const { theme } = useTheme()
  const dark = theme === 'dark'

  return (
    <span className={clsx('flex items-center gap-2', className || 'h-8')} {...props}>
      <img src={dark ? LOGO_FULL_WHITE : LOGO_FULL} alt="Safyro" className="h-full w-auto" />
      <span className="text-base font-semibold tracking-tight text-ink-900">Humania</span>
    </span>
  )
}

export function BrandMark({ className, ...props }) {
  return (
    <img
      src={LOGO_MARK}
      alt=""
      aria-hidden="true"
      className={clsx('size-7 rounded-lg bg-white p-1', className)}
      {...props}
    />
  )
}

/**
 * Los iconos de la hoja de marca son decorativos: siempre acompañan a un texto
 * visible, así que van con `alt=""` para que el lector de pantalla no los lea.
 */
export function BrandIcon({ name, className }) {
  const src = BRAND_ICONS[name]
  if (!src) return null
  return <img src={src} alt="" aria-hidden="true" className={clsx('size-6', className)} />
}
